import type { LinkTokens } from './types';

export const link: LinkTokens = {
  borderStyles: {
    base: '',
    underlined: 'dotted',
    legal: 'dotted',
    legalHover: 'dotted',
    legalUnderline: 'dotted',
    legalUnderlineHover: 'dotted',
    disabled: 'dotted',
  },
  borderWidths: {
    underlined: '2px',
    legal: '2px',
    legalHover: '2px',
    legalUnderline: '2px',
    legalUnderlineHover: '2px',
    disabled: '2px',
  },
  colors: {
    underlinedBorder: null,
    legalBorder: 'neutrals.4',
    disabledBorder: 'neutrals.4',
  },
  textDecoration: {
    legalHover: '2px dotted',
  },
};
